module.exports = __webpack_public_path__ + "img/type2.bd4f71c4.png";